<template>
  <div>
    <Header :home="false" :logged="logged" :arealogada="true"/>
    <!-- <Modal mensagem="Deseja anexar algum documento ?" @resposta="respConfirm" /> -->
    <b-modal ref="erroPush" @ok="confirmaErroPush" title="Atenção" :hide-header-close="true" :no-close-on-esc="true" :no-close-on-backdrop="true">
      <p>{{this.erroPushMsg}}</p>
    </b-modal>
    <b-modal 
      centered
      size="sm"
      title="Anuência SP"
      :ok-title-html="'Prosseguir'"
      :cancel-title-html="'Voltar'"
      ref="anuenciaSP" 
      @ok="redirect('https://protestosp.com.br/')"
      @cancel="objAnuencia.ufselecionada = ''" 
      :no-close-on-esc="true"
      :no-close-on-backdrop="true"
      :cancel-disabled="false"
      cancel-variant="danger"
      >
      <p>Para gerar uma Anuência para um título protestado no Estado de SP, clique em prosseguir.</p>
    </b-modal>
    <div
      class="text-center"
      v-if="loading"
      style="
        background: rgba(255, 255, 255, 0.7) none repeat scroll 0% 0%;
        width: 100%;
        height: 100%;
        position: absolute;
        display: block;
        z-index: 10002;
        margin: 0;
        top: 0;
        padding-top: 20%;
      "
    >
      <b-spinner
        variant="primary"
        style="width: 3rem; height: 3rem"
        label="Text Centered"
      ></b-spinner>
      <br /><span style="color: #004e86">Processando Aguarde...</span>
    </div>
    <b-modal
      ref="confirmaSemCertificado"
      size="x1"
      title="Atenção"
      @ok="redirecionaPainel"
      no-close-on-backdrop
      no-close-on-esc
    >
    <template #modal-header="">
      <h5>Atenção</h5>
    </template>
      Para utilizar o serviço de Autorização de Cancelamento é necessário estar logado por meio de Certificado Digital ICP-Brasil ou nivel Ouro via acesso .GOV.BR
    </b-modal>
    <b-modal
      ref="erro"
      title="Atenção"
      @ok="confirmar"
      :hide-header-close="true"
      :no-close-on-esc="true"
      :no-close-on-backdrop="true"
    >
      <p>{{ this.erro }}</p>
    </b-modal>
    <b-modal ref="erroTela" :title="erroTela.titulo" @hidden="resetarMsg">
      <p>{{ this.erroTela.msg }}</p>
    </b-modal>
    <b-modal
      ref="emailNotificacao"
      title="Cadastro de e-mail"
      centered
      @ok="gerarAnuencia"
      @cancel="emailNotificacao = ''"
      @hidden="emailNotificacao = ''"
      :no-close-on-esc="true"
      :no-close-on-backdrop="true"
      ok-title-html="Prosseguir"
      ok-variant="info"
      :cancel-disabled="true"
    >
      <b-row>
        <b-col cols="12">
          <b-form-group
            id="emailNotificacao"
            label="E-mail para Notificação"
            label-for="emailNotificacao"
            description="Endereço de e-mail a ser notificado quando o cancelamento for disponibilizado; será utilizado para todos os títulos"
            valid-feedback="Informação não obrigatória"
            :state="true"
          >
            <b-form-input
              id="emailNotificao"
              type="email"
              name="emailNotificacao"
              trim
              v-model="emailNotificacao"
              placeholder="E-mail para Notificação"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
    <Modal
      mensagem="Deseja gerar uma anuência eletronica para os títulos selecionado ?"
      @resposta="respConfirm"
    />
    <!--  @hidden="limparAnuenciaManual"       @show="limparAnuenciaManual" -->
    <b-modal
      ref="anuenciaManual"
      scrollable
      centered
      size="xl"
      title="Anuência Manual"
      @ok="gerar($event)"
      :ok-disabled="anuenciaManualModalBlocked"
      :no-close-on-esc="true"
      :no-close-on-backdrop="true"
      :cancel-disabled="false"
      :ok-title-html="'Gerar anuência manual'"
      :cancel-title-html="'Cancelar'"
      cancel-variant="danger"
    >
      <b-row>
        <b-col cols="12" md="4" lg="2">
          <b-form-group id="estado" label="Estado" label-for="estado">
            <b-form-select
              @change="selecionaUf($event)"
              v-model="objAnuencia.ufselecionada"
              :options="estados"
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="4" lg="3" v-if="mostrarMunicipios">
          <b-form-group
            id="estado"
            label="Selecione um município"
            label-for="estado"
          >
            <b-form-select
              @change="buscarCartorios($event)"
              v-model="objAnuencia.comarca"
              :options="municipios"
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="4" lg="7" v-if="mostrarCartorios">
          <b-form-group
            id="estado"
            label="Selecione um cartório"
            label-for="estado"
          >
            <b-form-select
              @change="selecionaCartorio($event)"
              :options="cartorios"
              v-model="objAnuencia.cartorioSelecionado"
            ></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row id="anuenciaManual_form">
        <b-col cols="12" md="6" lg="6">
          <b-form-group label="Nome do Devedor" label-for="nomeDevedor">
            <b-form-input
              id="nomeDevedor"
              v-model="objAnuencia.nomeDevedor"
              placeholder="Nome do Devedor"
              trim
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="6" lg="3">
          <b-form-group label="Documento do devedor" label-for="docDevedor">
            <the-mask
              :mask="['###.###.###-##', '##.###.###/####-##']"
              id="docDevedor"
              ref="docDevedor"
              v-model="objAnuencia.docDevedor"
              class="form-control"
              placeholder="CPF ou CNPJ"
              maxlength="18"
              @blur.native="validarDocumento($event, 'docDevedor')"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12" md="6" lg="3">
          <b-form-group label="Número do título" label-for="nrTituloDevedor">
            <b-form-input
              id="nrTituloDevedor"
              v-model="objAnuencia.nrTituloDevedor"
              placeholder="Número do título"
              trim
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="6" lg="3">
          <b-form-group label="Valor protestado" label-for="valorProtestado">
            <b-form-input
              id="valorProtestado"
              v-model="objAnuencia.valorProtestado"
              placeholder="R$ 0,00"
              @keyup="moeda"
              trim
              maxlength="21"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="4" lg="3">
          <b-form-group label="Data do Protesto" label-for="dtProtesto">
            <b-form-input
              id="dtProtesto"
              v-model="objAnuencia.dtProtesto"
              type="date"
              :max="_dataMaxima"
              required
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="4" lg="3">
          <b-form-group
            id="dtEmissao"
            label="Data da Emissão"
            label-for="dtEmissao"
          >
            <b-form-input
              id="dtEmissao"
              v-model="objAnuencia.dtEmissao"
              type="date"
              :max="_dataMaxima"
              required
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="4" lg="3">
          <b-form-group
            id="dtVencimento"
            label="Data do Vencimento"
            label-for="dtVencimento"
          >
            <b-form-input
              id="dtVencimento"
              v-model="objAnuencia.dtVencimento"
              type="date"
              :max="_dataMaxima"
              required
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row id="anuenciaManual_form">
        <b-col cols="12" md="4" lg="7">
          <b-form-group
            id="emailNotificacao"
            label="E-mail para Notificação"
            label-for="emailNotificacao"
            description="Endereço de e-mail a ser notificado quando o cancelamento for disponibilizado"
            valid-feedback="Informação não obrigatória"
            :state="true"
          >
            <b-form-input
              id="emailNotificaoManual"
              type="email"
              name="emailNotificacaoManual"
              trim
              v-model="emailNotificacao"
              placeholder="E-mail para Notificação"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal
      size="xl"
      ref="listaAnuencia"
      title="Deseja anexar algum documento ?"
      @ok="confirmaModalAnexo"
      :hide-header-close="true"
      :no-close-on-esc="true"
      :no-close-on-backdrop="true"
    >
      <p class="my-4">
        <template v-if="listaAnuencia.length > 0">
          <ul class="list-group">
            <li
              class="list-group-item"
              v-for="(anuencia, index) in listaAnuencia"
              :key="index"
            >
              <b-row>
                <b-col cols="3">
                  <b>Anuência:</b>
                  {{ anuencia.cd_anuencia_titulo }}
                </b-col>
                <b-col cols="3">
                  <b>Nr. Título:</b>
                  {{ anuencia.nr_titulo }}
                </b-col>
                <b-col cols="3">
                  <b>Vlr. Título:</b>
                  {{ anuencia.vlr_protesto }}
                </b-col>
                <b-col cols="3">
                  <b-form-file
                    @change="anexar(anuencia, index, $event)"
                    accept=".pdf"
                    label="Anexo"
                    placeholder="Escolha um arquivo"
                    v-model="anuencia.file"
                  ></b-form-file>
                </b-col>
              </b-row>
              <b-row v-if="anuencia.loadingAnexo">
                <b-col cols="12" class="text-center">
                  <b-spinner variant="primary" label="Spinning"></b-spinner>
                </b-col>
              </b-row>
              <b-row v-if="anuencia.arquivo_b64 !== ''">
                <b-col cols="12">
                  <b>Arquivo anexo: </b>
                  <a
                    :download="anuencia.cd_anuencia_titulo + '.pdf'"
                    :id="anuencia.cd_anuencia_titulo"
                    >{{ "anuencia_" + anuencia.cd_anuencia_titulo + ".pdf" }}</a
                  >
                  <font-awesome-icon
                    class="ml-4"
                    icon="trash"
                    color="red"
                    size="1x"
                    title="Excluir arquivo"
                    style="cursor: pointer"
                    @click="excluirArquivo(anuencia.cd_anuencia_titulo, index)"
                  />
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12">
                  <b-alert
                    class="mt-2"
                    :show="anuencia.sucesso !== ''"
                    :variant="anuencia.sucesso ? 'success' : 'danger'"
                    dismissible
                    fade
                  >
                    {{ anuencia.mensagem }}
                  </b-alert>
                </b-col>
              </b-row>
            </li>
            <li class="list-group-item">
              <b-row>
                <b-col cols="12">
                  <b-alert show variant="warning" dismissible fade>
                    Caso queira anexar procuração ou comprovante da extinção da
                    dívida. Somente arquivos no formato PDF são aceitos.
                  </b-alert>
                </b-col>
              </b-row>
            </li>
          </ul>
        </template>
      </p>
    </b-modal>
    <div id="painel" class="container-fluid">
      <b-row class="textAnuencia">
        <b-col cols="12" md="4" lg="3" v-if="show" style="padding: 0;" class="espaco-menu">
          <Menu class="d-none d-xl-block" />
        </b-col>
        <b-col cols="12" md="8" lg="9" class="flex" style="padding: 0;">
          <b-container fluid id="painelcontainerfluid">
            <b-row>
              <b-col cols="10" style="padding: 0;">
                <b-breadcrumb :items="breadCrumb"></b-breadcrumb>
              </b-col>
              <b-col cols="2" style="padding: 0.75rem 1rem;" >
                <b-link class="btn-voltar" href="/painel" style="text-decoration:none;font: normal normal 200 16px/24px 'Kanit', sans-serif;color:var(--primary-color);">
                  Voltar<img src="@/assets/imgs/icons/return-icon.svg" />
                </b-link>
              </b-col>
            </b-row>
            <h4 class="text-primary mt-5">
              Solicitar Autorização de Cancelamento
            </h4>
            <div>
              <div id="empresaCredoraCollapse" class="mt-2">
                <b-card>
                  <!-- formulario de pesquisar -->
                  <b-form name="frmBuscarAnuencia" id="frmBuscarAnuencia" @submit="pesquisar">
                    <b-row>
                      <b-col cols="12" md="12" lg="12">
                        <b-form-group size="sm" label="Empresa credora">
                          <b-form-select
                            disabled
                            id="empresaCredora"
                            :options="empresaCredora"
                            v-model="empresaCredoraSelected"
                          ></b-form-select>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <p class="card-text">Informe sua pesquisa</p>
                    <b-row>
                      <!-- 
                      <b-col cols="12" md="6" lg="6">
                        <b-form-group
                          label="Nome do Devedor"
                          label-for="nomeDevedor"
                        >
                          <b-form-input
                            id="pesqNomeDevedor"
                            v-model="form.nomeDevedor"
                            placeholder="Nome do Devedor"
                          ></b-form-input>
                        </b-form-group>
                      </b-col>
                      -->
                      <b-col cols="12" md="6" lg="3">
                        <b-form-group
                          label="Documento do devedor"
                          label-for="pesqDocDevedor"
                        >
                          <the-mask
                            :mask="['###.###.###-##', '##.###.###/####-##']"
                            id="pesqDocDevedor"
                            ref="pesqDocDevedor"
                            v-model="form.docDevedor"
                            class="form-control"
                            placeholder="CPF ou CNPJ"
                            maxlength="18"
                            @blur.native="
                              validarDocumento($event, 'pesqDocDevedor')
                            "
                          />
                        </b-form-group>
                      </b-col>
                      <!--
                      <b-col cols="12" md="6" lg="3">
                        <b-form-group
                          label="Número do título"
                          label-for="pesqNrTituloDevedor"
                        >
                          <b-form-input
                            id="pesqNrTituloDevedor"
                            v-model="form.nrTituloDevedor"
                            placeholder="Número do título"
                          ></b-form-input>
                        </b-form-group>
                      </b-col>
                      -->
                    </b-row>

                    <b-button @click="pesquisar" type="button" variant="primary">
                      <font-awesome-icon icon="search" /> Buscar
                    </b-button>
                    <b-button
                      @click="iniciarAnuenciaManual"
                      type="button"
                      variant="success"
                      class="pull-right"
                      v-if="habilitaAnuenciaAvulsa"
                      >Gerar Anuência Manual</b-button
                    >
                  </b-form>
                </b-card>
              </div>
            </div>
            <br />
            <div class="textAnuencia">
              <b-table
                v-if="rows > 0"
                id="my-table"
                ref="tabelaPesquisa"
                selectable
                striped
                hover
                :items="items"
                :per-page="perPage"
                :current-page="currentPage"
                :fields="fields"
                stacked="md"
                responsive="md"
                @row-selected="onRowSelected"
                class="textAnuencia"
              >
                <!-- formata o documento -->

                <template #cell(selecione)="row">
                  <b-form-checkbox
                    inline
                    @change="selecionarCheck($event, row.index)"
                    :id="`chkAnuencia${row.item.cd_titulo}`"
                    :checked="row.rowSelected || row.item.rowSelected"
                  ></b-form-checkbox>
                </template>
                <template #cell(nm_nr_documento_devedor)="row">
                  {{ row.item.nm_nr_documento_devedor | documento }}
                </template>
                <template #cell(NomeCartorio)="row">
                  <a href="javascript:void(null)" class="infoT fontP">
                    {{ row.item.NomeCartorio | cidadeCartorio }}
                    <span> {{ row.item.NomeCartorio | nomeCartorio }} </span>
                  </a>
                </template>
                <template #cell(dt_cadastro)="row">
                  {{ row.item.dt_cadastro | data }}
                </template>
                <template #cell(dt_ocorrencia)="row">
                  {{ row.item.dt_protocolo | data }}
                </template>
                <template #cell(vl_titulo)="row">
                  {{ row.item.vl_titulo | moeda }}
                </template>
                <template #cell(nm_devedor)="row">
                  <a href="javascript:void(null)" class="infoT fontP">
                    {{ row.item.nm_devedor | upper }}
                    <span> {{ row.item.nm_devedor }} </span>
                  </a>
                </template>
                <template #cell(nm_nr_protocolo)="row">
                  {{ row.item.nm_nr_protocolo }}
                </template>
                <template #cell(vl_protesto)="row">
                  {{ row.item.vl_protesto | moeda }}
                </template>
                <template #cell(actions)="row">
                  <b-button
                    class="center"
                    @click="baixarPDF(row.item.pdf)"
                    v-if="
                      row.item.cd_status !== 'Não Solicitado' &&
                      row.item.cd_status !== 'Finalizado'
                    "
                  >
                    <a
                      id="dwnldLnk"
                      :download="row.item.nm_chave"
                      style="display: none"
                    />
                    <font-awesome-icon icon="download" />
                  </b-button>
                </template>
              </b-table>
              <p>
                <b-pagination
                  v-if="rows > 0"
                  v-model="currentPage"
                  :total-rows="rows"
                  :per-page="perPage"
                  aria-controls="my-table"
                ></b-pagination>
              </p>
              <p v-if="rows > 0">
                <span class="pull-left">
                  <b-button @click="selectAllRows">Selecionar Todos</b-button
                  >&nbsp;&nbsp;
                  <b-button @click="clearSelected">Limpar Todos</b-button
                  >&nbsp;&nbsp;
                </span>
                <span style="float: right"
                  ><b-button
                    id="btn-gerar"
                    @click="$bvModal.show('modal-conf')"
                    variant="success"
                    v-if="habilitaga"
                    >Gerar Anuência para cancelamento</b-button
                  ></span
                >
              </p>
            </div>
            <div class="loading">
              <b-spinner
                variant="primary"
                style="width: 3rem; height: 3rem"
                label="Large Spinner"
                v-if="loading"
              ></b-spinner>
            </div>
          </b-container>
        </b-col>
      </b-row>
    </div>
    <footersite class="d-none d-xl-block"></footersite>
    <footersitemobile class="d-block d-xl-none"></footersitemobile>
  </div>
</template>

<script>
// import axios from "axios"
import Header from "../../components/Header";
import API from "../../services/api";
import Menu from "../../template/Menu";
import { TheMask } from "vue-the-mask";
import footersite from '../../components/footersite'
import footersitemobile from '../../components/footersite/index_mobile'

import Modal from "../../components/modal/Confmodal";

export default {
  components: {
    Header,
    Menu,
    TheMask,
    Modal,
    footersite,
    footersitemobile
  },
  data() {
    return {
      breadCrumb:[
        {text: 'Painel',href: "/painel" },
        {text: 'Cancelamento',disabled: true},
        {text: 'Novo Pedido',active: true}
      ],
      selectedFile: null,
      anuenciaManual: false,
      loading: false,
      perPage: 10,
      currentPage: 1,
      dismissSecs: 5,
      dismissCountDownDOC: 0,
      listaAnuencia: [],
      empresaCredoraSelected: null,
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
        conteudo: "",
      },
      infoModalDeletar: {
        id: "info-modal-deletar",
        title: "",
        conteudo: "",
      },
      fields: [
        { key: "selecione", label: "Selecione", tdClass: "text-center" },
        { key: "nm_nr_titulo", label: "Nº Título", sortable: false },
        { key: "sg_especie", label: "Espécie", sortable: false },
        { key: "NomeCartorio", label: "Cartório", sortable: true },
        { key: "nm_devedor", label: "Devedor", sortable: false },
        { key: "nm_nr_protocolo", label: "Nº Protocolo", sortable: true },
        { key: "nm_nr_documento_devedor", label: "Documento", sortable: true },
        { key: "dt_cadastro", label: "Cadastrado em", sortable: true },
        { key: "dt_ocorrencia", label: "Protestado em", sortable: true },
        { key: "vl_titulo", label: "Valor Título", sortable: true },
        { key: "vl_protesto", label: "Valor Protestado", sortable: true },
        { key: "cd_status", label: "Status Solicitação", sortable: true },
        { key: "actions", label: "Ação" },
      ],
      items: [],
      form: {
        // nomeDevedor: "",
        docDevedor: "",
        //nrTituloDevedor: "",
      },
      anuenciaManualModalBlocked:false,
      objAnuencia: {
        nomeDevedor: "",
        docDevedor: "",
        nrTituloDevedor: "",
        dtVencimento: "",
        valorProtestado: "R$ 0,00",
        dtProtesto: "",
        dtEmissao: "",
        ufselecionada: "",
        comarca: "",
        municipio: "",
      },
      emailNotificacao: "",
      empresaSelecionada: "",
      statusSelecionado: "",
      empresaCredora: [],
      statusSolicitacao: [],
      dadosDevedor: [],
      show: true,
      VempresaCredora: true,
      itemsSelecionados: [],
      erro: false,
      erroPushMsg: '',
      erroPushRoute: {name:'painel'},
      erroTela: { msg: "", titlo: "" },
      validaCampos: false,
      habilitaga: false,
      habilitaAnuenciaAvulsa: false,
      validaEmpresaSelecionada: false,
      resposta: false,
      estados: [],
      municipios: [],
      cartorios: [],
      mostrarMunicipios: false,
      mostrarCartorios: false,
    };
  },
  computed: {
    rows() {
      return this.items.length;
    },
    _dataMaxima() {
      return new Date().toLocaleDateString().split("/").reverse().join("-");
    },
  },
  created: function () {
    const token = localStorage.getItem("jwtToken");
    this.loading = true;
    setTimeout(() => {
      API.get(`usuario/dadosbancarios?token=${token}`).then((dadosBancarios) => {
        //  if (!res.data[0].nm_nr_cep || !res.data[0].nm_nr_telefone) { -- Nessa condição, nm_nr_cep E nm_nr_telefone são obrigatorios
        // if (!res.data[0].nm_nr_cep && !res.data[0].nm_nr_telefone) { // Nessa condição, somente um dos valores é obrigatorio
        //   this.blockForm('empresaCredoraCollapse');
        //   this.loading = false;
        //   this.erro = 'Cadastro do usuário incompleto. Para realizar esse procedimento é preciso fornecer mais informações.'
        //   this.errorPush = {name: 'cadastroUser'}
        //   // this.errorPush = {name: 'cadastroUser', params: {dadosLiq: 'liquidacao', dadosBancarios:0}}
        //   this.$refs['erro'].show();
        // }
        // else {
        // if (dadosBancarios.data === "") {
        //   this.blockForm('anuenciaManual_form');
        //   this.blockForm('frmBuscarAnuencia');
        //   this.loading = false;
        //   this.erroPushMsg = 'Cadastro do usuário incompleto. Para realizar esse procedimento é preciso fornecer mais informações.'
        //   this.erroPushRoute = {name: 'cadastroUser'}
        //   this.$refs['erroPush'].show();
        // }
        // else {
          this.buscaEstados();
          this.informacoesCertificado();
          this.logged = true;
          this.empresaCredoraSelected = localStorage.getItem("usrCpf");
          
          let loginComCertificado = 
            localStorage.getItem("sg_tipo_documento") && 
            localStorage.getItem("SSL_CLIENT_S_DN_CN") && 
            localStorage.getItem("nm_tipo_certificado") &&
            localStorage.getItem("SSL_CLIENT_S_DN") &&
            localStorage.getItem("SSL_CLIENT_V_START") &&
            localStorage.getItem("SSL_CLIENT_V_END");

          let govLogin = (localStorage.getItem('pxppwiru9') != undefined && localStorage.getItem('pxppwiru9') != null);
          let allowedGov = (govLogin ? ['3'].includes(localStorage.getItem("lhwvzhds3")) : false)

          if(govLogin){
            if(!allowedGov){
              this.loading = false;
              this.$refs["confirmaSemCertificado"].show();
            }
          }
          else {
            if(!loginComCertificado && localStorage.getItem("usrCpf") != "22055021826") { 
              setTimeout( () => { 
                this.loading = false;
                this.$refs["confirmaSemCertificado"].show() 
              },1)
            }
          }
          this.loading = false;
        // }
      });
    }, 1500);
    this.loading = false
  },
  filters: {
    moeda: function (value) {
      if (value) {
        return parseFloat(value).toLocaleString("pt-br", {
          style: "currency",
          currency: "BRL",
        });
      }
      return "R$ 0,00";
    },
    dataHora: function (value) {
      if (value !== "" && value !== undefined && value !== null) {
        let date = new Date(value);
        return date.toLocaleDateString("pt-BR", {
          hour: "numeric",
          minute: "numeric",
          year: "numeric",
          month: "numeric",
          day: "numeric",
        });
      }
      return "";
    },
    data: function (entrada) {
      if (entrada) {
        return entrada.split("-").reverse().join("/");
      }
      return "";
    },
    documento: function (entrada) {
      if (entrada) {
        let tamanho = entrada.toString().length,
          padraoCPF = /(\d{3})(\d{3})(\d{3})(\d{2})/,
          padraoCNPJ = /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
          subCPF = "$1.$2.$3-$4",
          subCNPJ = "$1.$2.$3/$4-$5";

        if (tamanho == 11) {
          return entrada.replace(padraoCPF, subCPF);
        } else if (tamanho == 14) {
          return entrada.replace(padraoCNPJ, subCNPJ);
        } else {
          return "";
        }
      }
      return "";
    },
    nomeCartorio: function (entrada) {
      if (entrada) {
        return entrada.split(" / ")[0];
      }
      return "";
    },
    cidadeCartorio: function (entrada) {
      if (entrada) {
        return entrada.split(" / ")[1];
      }
      return "";
    },
  },
  methods: {
    informacoesCertificado() {
      const cpfCertificado = localStorage.getItem("usrCpf"),
        nomeCertificado = localStorage.getItem("usrName");

      this.empresaCredora.push({
        value: cpfCertificado,
        text: `${nomeCertificado} - ${cpfCertificado}`,
      });
    },
    redirect(url){
      window.open(url); 
    },
    redirecionaPainel(){
      this.$router.push({
        name: "painel",
      });
    },
    validarDocumento: function (event, elemento) {
      var tamanho = event.target.value.length,
        texto = event.target.value,
        valor = "";
      if (texto != "") {
        if (tamanho > 14) {
          valor = this.validarCNPJ(texto);
        } else {
          valor = this.validarCPF(texto);
        }

        if (valor === false) {
          event.target.value = "";
          this.erro = "Documento Inválido!";
          this.$refs.erro.show();
          this.$refs[elemento].$el.focus();
          this.$refs[elemento].$el.text = "";
          if (elemento === "pesqDocDevedor") {
            this.form.docDevedor = "";
          } else if (elemento === "docDevedor") {
            this.objAnuencia.docDevedor = "";
          }
        }
      }
    },
    validarCPF(cpf) {
      if (typeof cpf !== "string") return false;
      cpf = cpf.replace(/\D/gim, "");
      if (
        !cpf ||
        cpf.length != 11 ||
        cpf == "00000000000" ||
        cpf == "11111111111" ||
        cpf == "22222222222" ||
        cpf == "33333333333" ||
        cpf == "44444444444" ||
        cpf == "55555555555" ||
        cpf == "66666666666" ||
        cpf == "77777777777" ||
        cpf == "88888888888" ||
        cpf == "99999999999"
      ) {
        return false;
      }
      var soma = 0;
      var resto;
      for (let i = 1; i <= 9; i++)
        soma = soma + parseInt(cpf.substring(i - 1, i)) * (11 - i);
      resto = (soma * 10) % 11;
      if (resto == 10 || resto == 11) resto = 0;
      if (resto != parseInt(cpf.substring(9, 10))) return false;
      soma = 0;
      for (let i = 1; i <= 10; i++)
        soma = soma + parseInt(cpf.substring(i - 1, i)) * (12 - i);
      resto = (soma * 10) % 11;
      if (resto == 10 || resto == 11) resto = 0;
      if (resto != parseInt(cpf.substring(10, 11))) return false;
      return true;
    },
    validarCNPJ(str) {
      let cnpj = str.replace(/\D/g, "");
      var numeros, digitos, soma, i, resultado, pos, tamanho, digitos_iguais;
      digitos_iguais = 1;
      if (cnpj.length < 14 && cnpj.length < 15) return false;
      for (let i = 0; i < cnpj.length - 1; i++)
        if (cnpj.charAt(i) != cnpj.charAt(i + 1)) {
          digitos_iguais = 0;
          break;
        }
      if (!digitos_iguais) {
        tamanho = cnpj.length - 2;
        numeros = cnpj.substring(0, tamanho);
        digitos = cnpj.substring(tamanho);
        soma = 0;
        pos = tamanho - 7;
        for (i = tamanho; i >= 1; i--) {
          soma += numeros.charAt(tamanho - i) * pos--;
          if (pos < 2) pos = 9;
        }
        resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
        if (resultado != digitos.charAt(0)) return false;
        tamanho = tamanho + 1;
        numeros = cnpj.substring(0, tamanho);
        soma = 0;
        pos = tamanho - 7;
        for (i = tamanho; i >= 1; i--) {
          soma += numeros.charAt(tamanho - i) * pos--;
          if (pos < 2) pos = 9;
        }
        resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
        if (resultado != digitos.charAt(1)) return false;
        return true;
      } else return false;
    },
    respConfirm(resp) {
      if (resp.respostaFinal == "s") {
        if (this.anuenciaManual) {
          this.gerar();
        } else {
          this.modalEmailNotificacao();
          //this.gerarAnuencia();
        }
      }
      this.anuencia_manual = false;
    },
    onchange: function (event) {
      this.empresaSelecionada = event;
      this.validaCampos = false;
      this.validaEmpresaSelecionada = false;
    },
    excluirArquivo(cd_anuencia_titulo, index) {
      const token = localStorage.getItem("jwtToken");
      this.listaAnuencia[index].loadingAnexo = true;
      API.post("anuencia/anexo/excluir", {
        token: token,
        cd_anuencia_titulo: cd_anuencia_titulo,
      }).then((res) => {
        this.listaAnuencia[index].sucesso = res.data.sucesso;
        this.listaAnuencia[index].mensagem = res.data.mensagem;
        this.listaAnuencia[index].arquivo_b64 = "";
        this.listaAnuencia[index].loadingAnexo = false;
      });
    },
    anexar: function (dadosAnuencia, index, event) {
      if (event.target.files[0].type == "application/pdf") {
        this.listaAnuencia[index].file = null;
        this.listaAnuencia[index].loadingAnexo = true;
        const token = localStorage.getItem("jwtToken");
        const fd = new FormData();
        fd.append("file", event.target.files[0]);
        fd.append("token", token);
        fd.append("cd_anuencia_titulo", dadosAnuencia.cd_anuencia_titulo);
        API.post("anuencia/anexo", fd).then((res) => {
          this.listaAnuencia[index].sucesso = res.data.sucesso;
          this.listaAnuencia[index].mensagem = res.data.mensagem;
          this.listaAnuencia[index].arquivo_b64 = res.data.arquivo_b64;
          this.listaAnuencia[index].loadingAnexo = false;
        });
      } else {
        this.listaAnuencia[index].file = null;
        this.listaAnuencia[index].sucesso = 0;
        this.listaAnuencia[index].mensagem =
          "Arquivo não suportado, por favor insira apenas arquivo PDF";
      }
    },
    confirmaModalAnexo() {
      let self = this;

      setTimeout(function () {
        self.$router.go({ name: "anuenciaDigital" });
      }, 2000);
    },
    selectStatus: function (event) {
      this.statusSelecionado = event;
    },
    exibirCollapse: function () {
      this.VempresaCredora = false;
    },
    numerosLetras: function (event) {
      let val = String(event.target.value);
      val = val.replace(/[^0-9a-zA-Z]/g, "");
      event.target.value = val;
    },
    moeda: function (event) {
      let valor = String(event.target.value);
      valor = valor.replace(/[\D]+/g, "");
      if (valor != "") {
        valor = valor + "";
        valor = valor.replace(/[\D]+/g, "");
        valor = valor + "";
        valor = valor.replace(/([0-9]{2})$/g, ",$1");
        valor = valor.replace(/(\d)(\d{3}),/g, "$1.$2,");
        valor = valor.replace(/(\d+)(\d{3}.*)/, "$1.$2"); //Coloca o resto dos pontos
        valor = valor.replace(/(\d+)(\d{3}.*)/, "$1.$2");
        valor = valor.replace(/(\d+)(\d{3}.*)/, "$1.$2");
        valor = valor.replace(/(\d+)(\d{3}.*)/, "$1.$2");
      } else {
        valor = "";
      }
      event.target.value = "R$ " + valor;
    },
    resetarMsg: function () {
      this.erroTela.titulo = "";
      this.erroTela.msg = "";
    },
    gerarMsgTela: function (titulo, msg) {
      this.erroTela.titulo = titulo;
      this.erroTela.msg = msg;
      this.$refs.erroTela.show();
    },
    validarPesquisa: function () {
      if (
        // !this.form.nomeDevedor &&
        !this.form.docDevedor
        //!this.form.nrTituloDevedor &&
      ) {
        this.gerarMsgTela(
          "Aviso",
          "Forneça ao menos um parâmetro para poder pesquisar"
        );
        return false;
      } /*else if ( this.form.nomeDevedor.trim() && this.form.nomeDevedor.trim().length < 3 ) {
        this.gerarMsgTela( "Aviso", "Nome do devedor deve possuir ao menos três letras" );
        return false;
      } */ else if (
        this.form.docDevedor &&
        this.form.docDevedor.replace(/(\D)/, "").length < 4
      ) {
        this.gerarMsgTela(
          "Aviso",
          "Número de documento (CPF/CNPJ) deve possuir ao menos três digitos"
        );
        return false;
      }
      return true;
    },
    async pesquisar(event) {
      if (this.validarPesquisa()) {
        event.preventDefault();
        this.loading = true;
        const token = localStorage.getItem("jwtToken");

        API.post("anuencia", { token: token, ...this.form })
          .then((res) => {
            this.loading = false;
            this.items = res.data;
            this.erro =
              "Caso não tenha localizado o título desejado, clique em Gerar Anuência Manual";
            this.$refs.erro.show();
            this.habilitaAnuenciaAvulsa = true;
          })
          .catch((err) => {
            this.loading = false;
            console.log(err);
            this.erro =
              "Não foi possível realizar a pesquisa, verifique se sua sessão de acesso permanece ativa";
            this.$refs.erro.show();
          });
      }
    },
    baixarPDF: function (pdf) {
      var dlnk = document.getElementById("dwnldLnk");
      dlnk.href = "data:application/pdf;base64," + pdf;
      dlnk.click();
    },
    onRowSelected(item) {
      if (item.length) {
        item.forEach((e, i) => {
          const status = ["Não Solicitado", "Finalizado", "Anuencia Excluida pelo Solicitante"];
          if (status.indexOf(item[i].cd_status) >= 0) {
            this.itemsSelecionados = item;
            if (this.itemsSelecionados.length > 0) {
              this.habilitaga = true;
            } else {
              this.habilitaga = false;
            }
          }
        });
      } else {
        this.habilitaga = false;
      }
    },
    selectAllRows() {
      //console.log(this.$refs.tabelaPesquisa.$props)
      this.items.forEach((element, index) => {
        if (this.items[index].cd_status == "Não Solicitado") {
          this.$set(this.items[index], "rowSelected", true);
          this.itemsSelecionados = this.items;
          if (this.itemsSelecionados.length > 0) {
            this.habilitaga = true;
          }
        } else this.habilitaga = false;
      });

      //this.$refs.tabelaPesquisa.selectAllRows()
    },
    clearSelected() {
      this.items.forEach((element, index) => {
        this.$set(this.items[index], "rowSelected", false);
      });
      this.itemsSelecionados = [];
      this.$refs.tabelaPesquisa.clearSelected();
      this.habilitaga = false;
    },
    limparAnuenciaManual() {
      this.objAnuencia.nomeDevedor = "";
      this.objAnuencia.docDevedor = "";
      this.objAnuencia.nrTituloDevedor = "";
      this.objAnuencia.dtVencimento = "";
      this.objAnuencia.valorProtestado = "R$ 0,00";
      this.objAnuencia.dtProtesto = "";
      this.objAnuencia.dtEmissao = "";
      this.objAnuencia.ufselecionada = "";
      this.objAnuencia.comarca = "";
      this.objAnuencia.municipio = "";
      this.objAnuencia.cartorioSelecionado = "";
      this.emailNotificacao = "";
    },
    iniciarAnuenciaManual() {
      this.abrirAnuenciaManual();
      this.objAnuencia.docDevedor = this.form.docDevedor;
      this.blockForm('anuenciaManual_form');
    },
    abrirAnuenciaManual() {
      this.$refs.anuenciaManual.show();
    },
    validarAnuenciaManual() {
      if (
        this.objAnuencia.nrTituloDevedor == "" ||
        this.objAnuencia.dtProtesto == "" ||
        this.objAnuencia.nomeDevedor == "" ||
        this.objAnuencia.docDevedor == "" ||
        this.objAnuencia.dtEmissao == "" ||
        this.objAnuencia.dtVencimento == "" ||
        this.objAnuencia.valorProtestado == "" ||
        this.objAnuencia.cartorioSelecionado == ""
        // || this.objAnuencia.municipio == ""
      ) {
        // console.log(this.objAnuencia)
        this.erro =
          "Todos os campos do formulário de anuência manual são obrigatórios";
        this.$refs.erro.show();
        return false;
      }
      return true;
    },
    modalEmailNotificacao() {
      this.$refs.emailNotificacao.show();
    },
    async gerarAnuencia() {
      let bt = document.getElementById("btn-gerar");
      //console.log(this.itemsSelecionados)
      this.loading = true;
      bt.disabled = true;
      const token = localStorage.getItem("jwtToken");
      const gIdTk = localStorage.getItem('t178w3gm3');

      const res = await API.post(`anuencia/gerar`, {
        dados: this.itemsSelecionados,
        token: token,
        gIdTk: gIdTk,
        dadosDevedor: this.dadosDevedor,
        email: this.emailNotificacao,
        documentoCredor: localStorage.getItem("nm_nr_documento_cert"),
        sg_tipo_documento: localStorage.getItem("sg_tipo_documento"),
        SSL_CLIENT_S_DN_CN: localStorage.getItem("SSL_CLIENT_S_DN_CN"),
        nm_tipo_certificado: localStorage.getItem("nm_tipo_certificado"),
        SSL_CLIENT_S_DN: localStorage.getItem("SSL_CLIENT_S_DN"),
        SSL_CLIENT_V_START: localStorage.getItem("SSL_CLIENT_V_START"),
        SSL_CLIENT_V_END: localStorage.getItem("SSL_CLIENT_V_END"),
      });

      //let res = { data : { sucesso : 1, descricao : "Anuência gerada com sucesso"}}
      this.erro = res.data.descricao;

      if (res.data.sucesso) {
        this.listaAnuencia = res.data.listaAnuencia;
        this.resposta = true;
      }
      //res.data.sucesso = 1;
      this.loading = false;
      this.$refs.erro.show();

      /*setTimeout(function(){ 
            if(res.data.sucesso)self.$router.go({name:"anuenciaDigital"})
          }, 2000);*/
    },
    async buscaEstados() {
      const res = await API.get(`/uf`);
      this.estados = res.data;
      this.estados.push({"value":"35","text":"SP"});
      this.estados.sort((a, b) => {
        if (a.text < b.text) return -1;
        if (a.text > b.text) return 1;
        return 0;
      });

      // this.loading = false;
    },
    selecionaUf(iduf) {
      this.objAnuencia.comarca = "";
      this.objAnuencia.cartorioSelecionado = "";
      if(iduf != '35'){ // 35 - SP
        this.unBlockForm('anuenciaManual_form');
        this.buscarMunicipios(iduf);
        this.estadoSelecionado = iduf;
      }
      else {
        this.blockForm('anuenciaManual_form');
        this.$refs.anuenciaSP.show();
        this.estadoSelecionado = "";
        this.mostrarMunicipios = false;
        this.mostrarCartorios = false;
      }
    },
    async buscarMunicipios(iduf) {
      this.loading = true;
      const res = await API.get(`/municipios?iduf=` + iduf);
      this.municipios = res.data;
      this.mostrarMunicipios = true;
      this.loading = false;
    },
    async buscarCartorios(cdibge) {
      this.loading = true;
      const res = await API.get(`/cartorios?cdibge=` + cdibge);
      this.cartorios = res.data;
      this.mostrarCartorios = true;
      this.form.municipio = cdibge;
      this.loading = false;
    },
    selecionaCartorio(cartorio) {
      this.form.cartorioSelecionado = cartorio;
    },
    async gerar(event) {
      if (this.validarAnuenciaManual()) {
        this.loading = true;
        const token = localStorage.getItem("jwtToken");
        const gIdTk = localStorage.getItem("t178w3gm3");

        var dados = {
          nm_nr_titulo: this.objAnuencia.nrTituloDevedor,
          dtOcorrencia: this.objAnuencia.dtProtesto,
          nomedevedor: this.objAnuencia.nomeDevedor,
          docDevedor: this.objAnuencia.docDevedor,
          dtEmissao: this.objAnuencia.dtEmissao,
          dtVencimento: this.objAnuencia.dtVencimento,
          valorProtestado: this.objAnuencia.valorProtestado,
          cartorio: this.objAnuencia.cartorioSelecionado,
          ibge: this.objAnuencia.municipio,
        };

        const res = await API.post(`anuencia/gerar`, {
          dados: dados,
          token: token,
          gIdTk: gIdTk,
          anuencia_avulsa: 1,
          email: this.emailNotificacao,
          documentoCredor: localStorage.getItem("nm_nr_documento_cert"),
          sg_tipo_documento: localStorage.getItem("sg_tipo_documento"),
          SSL_CLIENT_S_DN_CN: localStorage.getItem("SSL_CLIENT_S_DN_CN"),
          nm_tipo_certificado: localStorage.getItem("nm_tipo_certificado"),
          SSL_CLIENT_S_DN: localStorage.getItem("SSL_CLIENT_S_DN"),
          SSL_CLIENT_V_START: localStorage.getItem("SSL_CLIENT_V_START"),
          SSL_CLIENT_V_END: localStorage.getItem("SSL_CLIENT_V_END"),
        });
        //this.erro = res.data.descricao;
        //let res = { data : { sucesso : 1, descricao : "Anuência gerada com sucesso"}}
        this.erro = res.data.descricao;
        //res.data.sucesso = 1;
        this.loading = false;
       
        if(res.data.nao_localizado)  this.abrirAnuenciaManual();
        else if (res.data.sucesso) {
          this.listaAnuencia = res.data.listaAnuencia;
          this.resposta = true;
        }
        this.$refs.erro.show();
      } else {
        event.preventDefault();
      }
    },
    confirmar() {
      if (this.resposta) {
        this.limparFiltro();
        this.$refs.listaAnuencia.show();
      }
    },
    limparFiltro() {
      // this.form.nrTituloDevedor = "";
      // this.form.dtProtesto = "";
      // this.form.nomeDevedor = "";
      this.form.docDevedor = "";
      // this.form.dtEmissao = "";
      // this.form.nrProtocolo = ''
      // this.form.dtProtocolo = ''
      // this.form.dtVencimento = "";
      // this.form.valorProtestado = "";
      // this.form.cartorioSelecionado = "";
      // this.form.municipio = "";
    },
    selecionarCheck(estado, linha) {
      if (estado) {
        this.$refs.tabelaPesquisa.selectRow(linha);
      } else {
        this.$refs.tabelaPesquisa.unselectRow(linha);
      }
    },
    confirmaErroPush(){
      this.$router.push(this.erroPushRoute);
      this.$refs['erroPush'].hide();
    },
    blockForm(formId){
      setTimeout(() => {
        var forms = document.querySelectorAll(`#${formId}`);
        if (forms) {
          forms.forEach(form => {
            var elementsToDisable = form.querySelectorAll('input, select, textarea, button, a');
            elementsToDisable.forEach(element => {element.disabled = true;});
          });
          this.anuenciaManualModalBlocked = true;
        }
      }, 10); 
    },
    unBlockForm(formId){
      var forms = document.querySelectorAll(`#${formId}`);
      if (forms) {
        forms.forEach(form => {
          var elementsToDisable = form.querySelectorAll('input, select, textarea, button, a');
          elementsToDisable.forEach(element => {element.disabled = false;});
        });
        this.anuenciaManualModalBlocked = false;
      }
    }
  },
};
</script>

<style scoped>
#wrapper-spinner {
  position: absolute;
  left: 0px;
  bottom: 0px;
  width: 100%;
  height: calc(100% - 80px);
}

#wrapper-spinner .v-spinner {
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -10px 0px 0px -20px;
}

#painel {
  position: fixed;
  width: 100%;
  left: 0px;
  bottom: 0px;
  padding-top: 0px;
  height: calc(100% - 80px);
  overflow-x: hidden;
    border-top: 1px solid #f1f1f1;
}
.lista-certidoes {
  color: #000;
}
.lista-certidoes b {
  font-size: 0.85rem;
  color: var(--main-azul);
}

a {
  color: #555;
}
.shadow {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}

#loading-solicitante {
  vertical-align: 0;
  margin-left: -21px;
}

.load {
  top: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.spin {
  background: #fff;
  height: 80px;
  width: 80px;
  border-radius: 50vh;
  border-color: #209cee;
  border-top: 5px solid #209cee;
  animation: loading 3s linear infinite;
}

.loading {
  position: absolute;
  color: #000;
  width: 100%;
  text-align: center;
}
@keyframes loading {
  100% {
    transform: rotate(360deg);
  }
}
.bold {
  font-weight: bold;
}
.mensagemErro {
  color: red;
}
@media (min-width: 980px) and (max-width: 1300px) {
  .table {
    font-size: 11px;
  }
}



#painel > .row{justify-content: space-between;}

#painel{scrollbar-width:none;}
#painel::-webkit-scrollbar{display:none;}
.espaco-menu{width: calc(296px + 5px + 5px);flex: unset;margin-left: calc(3.8vw - 5px);}
#painel h1 {text-align: left;font: normal normal bold 25px/41px 'Kanit', sans-serif; letter-spacing: 0px;color: #597EB5;margin-bottom: 33px;}

#painelcontainerfluid{padding:0;padding-bottom: 52px;padding-right: 3.8vw;margin-top: 37px;margin-bottom: 70px;}
@media (max-width:1600px) and (min-width:1400px){
  .espaco-menu{margin-left: calc(20px - 5px) !important;}  
  #painelcontainerfluid{padding-right: 20px !important;}
}
@media (max-width:1399px) and (min-width:1200px){
  .espaco-menu{margin-left: calc(10px - 5px) !important;}
  #painelcontainerfluid{padding-right: 10px !important;}
}
@media (max-width:1199px){
  #painel {padding:0 17px;}
  #painel > .row{
    width: 100%;
    /* max-width: none; */
    margin: 0 !important;
    padding: 0px !important;
    margin-bottom: 70px !important;
    /* margin-left: -17px !important; */
    max-width: 100%;
    margin-left: 0px !important;
  }
  .col-lg-9{max-width: none;flex: 1 1 100%;padding: 0;}
  #painelcontainerfluid{padding:0px !important;}
}
.breadcrumb{margin-left: 0px;background: unset;}
.breadcrumb a, .breadcrumb span, .breadcrumb-item + .breadcrumb-item::before{font: normal normal 200 16px/20px 'Kanit', sans-serif;}
.breadcrumb-item + .breadcrumb-item::before{float:unset;}
.breadcrumb a{color: var(--primary-color);}
.breadcrumb-item + .breadcrumb-item::before{color: var(--primary-color);}
.breadcrumb span{color: var(--secondary-color);}
.breadcrumb a.disabled{text-decoration:none;cursor:default;}
.btn-voltar {display: flex;align-items: center;margin-left: auto;letter-spacing: 0px;text-decoration: none;justify-content: flex-end !important;margin-bottom: 20px;}
.btn-voltar img{width: 20px;height: 20px;margin-left: 6px;}


</style>
